const { getOffsetTop } = window.BAO.Utils

class ProductFixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  handleTrigger () {
    const formPosition = getOffsetTop(this.externalEls.scrollto.element) - 105

    window.scrollTo(0, formPosition)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    this.setAttribute('aria-hidden', !this.shouldBeVisible)
  }

  get shouldBeVisible () {
    if (!this.externalEls?.form?.exists) return

    const formFooter = this.externalEls.form.element
    const pageFooter = this.externalEls.footer.element

    if (formFooter.offsetParent === null || pageFooter.offsetParent === null) {
      return false
    }

    if (
      this.lastKnownY > getOffsetTop(formFooter) + formFooter.offsetHeight &&
      this.lastKnownY < getOffsetTop(pageFooter) - window.innerHeight / 2
    ) {
      return true
    } else {
      return false
    }
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
